import React from 'react';

export default class LayersList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      project: props.project
    };
  }

  toggleVisibility(layer, e) {
    e.preventDefault();
    e.stopPropagation();

    layer.toggleVisibility();
  }

  removeLayer(layer, e) {
    e.preventDefault();
    e.stopPropagation();

    layer.remove();
  }

  selectLayer(layer, e) {
    e.preventDefault();
    e.stopPropagation();

    layer.select();
    this.state.project.viewport.moveToSelection();
  }

  render() {
    let project = this.state.project;

    return (
      <div className="ui segment" id="layersListWrapper">
        <div className="ui relaxed divided list" id="layersList">
          {project.activePage && project.activePage.layers.map(layer => {
            return (
              <div key={layer.id} className={project.activePage.selectedLayer == layer ? 'selected item' : 'item'} onClick={this.selectLayer.bind(this, layer)}>
                <div className="left floated content">
                  <i className={layer.visible ? 'icon unhide' : 'icon hide'} onClick={this.toggleVisibility.bind(this, layer)} />
                </div>
                <div className="right floated content">
                  {layer != project.activePage.sourceLayer &&
                    <i className="remove icon" onClick={this.removeLayer.bind(this, layer)} />
                  }
                </div>
                <div className="content">
                  {layer.name}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
